// extracted by mini-css-extract-plugin
export var heading2 = "PageDataBodyRichText-module--heading2--vSOta";
export var heading3 = "PageDataBodyRichText-module--heading3--XUzd5";
export var heading4 = "PageDataBodyRichText-module--heading4--nuOb9";
export var heading5 = "PageDataBodyRichText-module--heading5--eZqFv";
export var link = "PageDataBodyRichText-module--link--gWiyj";
export var list = "PageDataBodyRichText-module--list--dlAwq";
export var orderedList = "PageDataBodyRichText-module--orderedList--U7hPF";
export var paragraph = "PageDataBodyRichText-module--paragraph--YbTXl";
export var richText = "PageDataBodyRichText-module--richText--KZ-u+";